import styled from 'styled-components';
import {
  Modal as ModalComponent,
  ListGroup as ListGroupComponent,
} from 'react-bootstrap';

export const Modal = styled(ModalComponent)`
  .modal-content {
    border: none;
    background: #ffffff;
    border-radius: 10px;

    .modal-header {
      margin: 5px 0;
    }

    h4 {
      font-weight: bold;
      font-size: 18px;
      line-height: 20px;
      color: #414141;
      margin: 0;
    }

    label {
      font-weight: 500;
      color: #414141;
    }

    .input {
      border: 1px solid #d9d9d9;
      border-radius: 10px;

      input {
        font-weight: 500;
        color: #605e5e;
      }
    }

    .close {
      font-size: 24px;
      border: none;
      position: absolute;
      right: 40px;
      font-size: 30px;

      .sr-only {
        display: none;
      }
    }

    .buttons-group {
      button {
        height: 40px;
        border-radius: 10px;
        border: 2px solid transparent;
        padding: 2px 4px 2px 4px;
      }

      button[type='button'] {
        color: #d9d9d9;
        font-weight: 500;
        border-color: #d9d9d9;
      }

      button.btn-approve {
        color: #ffffff;
        font-weight: bold;
        background: #2e90fd;
      }

      button.btn-not-approve {
        color: #ffffff;
        font-weight: bold;
        background: red;
      }
    }
  }
`;

export const ListGroup = styled(ListGroupComponent)`
  span {
    color: blue;
  }
`;
